import React, { useState, useEffect } from "react";
import axios from "axios";

const WorkspaceModal = ({ isOpen, onClose, selectedWorkspaceId, onSave }) => {
  const [workspaces, setWorkspaces] = useState([]);
  const [filteredWorkspaces, setFilteredWorkspaces] = useState([]);
  const [selectedWorkspaceIdForAgent, setSelectedWorkspaceIdForAgent] = useState(null); // Store workspace_id
  const [searchTerm, setSearchTerm] = useState("");
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (isOpen) {
      fetchWorkspaces();
    }
  }, [isOpen]);

  const fetchWorkspaces = async () => {
    try {
      const response = await axios.get("https://apiplatform.finkraft.ai/meta/workspaces");
      const workspaceList = response.data;
      const intermediaryWorkspaces = workspaceList.filter(
        (workspace) => workspace.entity_type === "INTERMEDIARY"
      );

      setWorkspaces(intermediaryWorkspaces);
      setFilteredWorkspaces(intermediaryWorkspaces);
    } catch (error) {
      console.error("Error fetching workspaces:", error);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter workspaces based on search term
    if (value) {
      const filtered = workspaces.filter((workspace) =>
        workspace.name.toLowerCase().includes(value)
      );
      setFilteredWorkspaces(filtered);
    } else {
      setFilteredWorkspaces(workspaces); // Show all workspaces if search is empty
    }
  };

  // Update selectedWorkspaceIdForAgent to store the workspace ID
  const handleSelectWorkspace = (id) => {
    setSelectedWorkspaceIdForAgent(id);
  };

  const handleSave = async () => {
    if (selectedWorkspaceIdForAgent) {
      try {
        // API call to update the agent_name using workspace ID
        const payload = {
          workspace_id: selectedWorkspaceId, // ID of the workspace you're updating
          agent_name: selectedWorkspaceIdForAgent // Selected workspace ID for the agent name
        };
  
        const response = await axios.post(
          "https://stage-apiplatform.finkraft.ai/api/meta/update-agent-name", // Your API endpoint
          payload,
          {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        );
  
        if (response.status === 200) {
          console.log("Agent name updated successfully.");
          onSave({
            agentId: selectedWorkspaceIdForAgent, // Send updated agentId (selected workspace)
            workspaceId: selectedWorkspaceId // Send the current workspaceId
          });
          onClose(); // Close modal after saving
        } else {
          console.log("Failed to update agent name.");
        }
  
        
  
      } catch (error) {
        console.error("Error updating agent name:", error);
      }
    }
  };
  

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Agent Name for Workspace ID: {selectedWorkspaceId}</h2>
        <input
          type="text"
          placeholder="Search workspaces..."
          value={searchTerm}
          onChange={handleSearch}
        />
        <div className="workspace-list">
          {filteredWorkspaces.map((workspace) => (
            <div key={workspace.id} className="workspace-item">
              <input
                type="radio"
                name="workspace"
                value={workspace.id}
                checked={selectedWorkspaceIdForAgent === workspace.id}
                onChange={() => handleSelectWorkspace(workspace.id)} 
              />
              <label>{workspace.name}</label>
            </div>
          ))}
        </div>
        <div className="modal-footer">
          <button onClick={onClose}>Back</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceModal;
